import type { RunMode } from "./hubRunner";
import type { HubRow, PartRun, RowRun } from "./hubTypes";
import { rowView, summarizeRows } from "./rowState";

export const RELOAD_STEP = "Para volver a validar o subir, toca «Cargar filas».";
// A validation leaves the buttons enabled, so its next step is the upload.
const UPLOAD_STEP = "Para subir lo que está listo, toca «Subir pendientes».";

interface RunReportInput {
  mode: RunMode;
  // Detener, or a failure that cut the run short.
  stopped: boolean;
  rows: HubRow[];
  runs: Record<number, RowRun>;
  // «Volver a subir lo ya subido»: a ticked part was not done before this run.
  reupload?: boolean;
}

const count = (n: number, one: string, many: string) =>
  `${n} ${n === 1 ? one : many}`;

// What this run did, counted per part from its own results: what it marked as
// uploaded or valid, and the errors of the rows it got through. A part that was
// done before it, and a row it never reached, count nowhere.
export function runReport({
  mode,
  stopped,
  rows,
  runs,
  reupload = false,
}: RunReportInput): string {
  const settled = rows.filter(
    (row) => runs[row.rowNumber]?.messages !== undefined,
  );
  const marked = (part: "doc" | "quiz", status: PartRun) =>
    settled.filter((row) => runs[row.rowNumber][part] === status).length;
  const { doc, quiz } = summarizeRows(
    settled.map((row) => rowView(row, runs[row.rowNumber], { reupload })),
  );
  const withError = doc.withError + quiz.withError;

  const done =
    mode === "upload"
      ? `${count(marked("doc", "done"), "OD subido", "OD subidos")}, ${count(marked("quiz", "done"), "quiz subido", "quizzes subidos")}`
      : count(
          marked("doc", "valid") + marked("quiz", "valid"),
          "parte lista para subir",
          "partes listas para subir",
        );
  const run = mode === "upload" ? "La carga" : "La validación";
  const next = mode === "upload" ? RELOAD_STEP : UPLOAD_STEP;
  return `${run} ${stopped ? "se detuvo" : "terminó"}: ${done} y ${withError} con error. ${next}`;
}
